import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=183b0260&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=js&"
export * from "./TextBox.vue?vue&type=script&lang=js&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=183b0260&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b0260",
  null
  
)

export default component.exports